import type { NavItem } from "types/backend/models/admin/navbar.entity";
import type { Image } from "types/backend/models/cms/image.entity";

export interface IMenu {
  label: string;
  items: NavItem[];
  layout: "single-column" | "double-column";
  buttons?: IMenuButton[];
}

export interface IMenuButton {
  label: string;
  url?: string;
  icon?: Partial<Image>;
  backgroundColor?: string;
  color?: string;
  callback?: () => void | Promise<void>;
}

export enum CustomerType {
  SELLER = "seller",
  BROKER = "broker",
  CUSTOMER = "customer",
  STAFF = "staff",
  WEB_AFFILIATE = "ticketpad-affiliate",
}
